// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel.js';
import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description TripleCheck Request and Result Search Response
*/
export class EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel {
    'request'?: EServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel | null;
    'result'?: EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel>> = [
        {
            "name":     "request",
            "baseName": "request",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckRequestModel"
        },
        {
            "name":     "result",
            "baseName": "result",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsTripleCheckTransactionSearchResponseModel.attributeTypeMap;
    }
}
